import http from 'plugins/axios';

export default {
    createBatchSendEmailTask(data) {
        return http.post({
            url: '/admin/batch/email/create',
            data,
            dataType: 'form'
        });
    },

    getBatchSendEmailTask(data) {
        return http.get({
            url: '/admin/batch/email/task/query',
            data
        });
    },

    getEmailSendLog(data) {
        return http.get({
            url: '/admin/batch/email/record/query',
            data
        })
    },

    deleteBatchSendEmailTask(data) {
        return http.post({
            url: '/admin/task/email/task/delete',
            data,
            dataType: 'form'
        })
    }
};
